/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { Redirect } from "react-router-dom";

import { Text } from "@fluentui/react";

import { useAuth } from "Authentication/AuthProvider";
import { AAD_REPLYURL_SESSIONSTORAGE_KEY } from "Constants/AuthenticationConstants";
import { DetailWrapper } from "Containers/Common/CommonContainer.styles";

const HomeContainer = (): ReactElement => {
  const { isUserLoggedIn, loading, hasAnyRoles } = useAuth();

  const redirectUrl = sessionStorage.getItem(AAD_REPLYURL_SESSIONSTORAGE_KEY);
  if (isUserLoggedIn && !!redirectUrl) {
    // If user is authenticated and has redirect url, then redirect.
    sessionStorage.removeItem(AAD_REPLYURL_SESSIONSTORAGE_KEY);
    return <Redirect to={redirectUrl} />;
  }

  if (isUserLoggedIn && !hasAnyRoles && !loading) {
    return <Redirect to="/unauthorized" />;
  }

  const text = isUserLoggedIn
    ? "Welcome to the MVP Communities Admin Center. Please select an option to continue."
    : "Please log in to continue.";

  return (
    <DetailWrapper>
      <Text>{text}</Text>
    </DetailWrapper>
  );
};

export default HomeContainer;
